export const ADDITIONAL_INFO_KEY = "USER_FILLED_ADDITIONAL_INFO";
export const EMAIL_INFO_KEY = "USER_FILLED_EMAIL_INFO";
